var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-grid",
    [
      _c(
        "sui-grid-row",
        [
          _c("sui-grid-column", { attrs: { width: 8 } }, [
            _c("h3", { staticClass: "is-sui-header client-header" }, [
              _vm._v(" Client "),
              _c("span", { staticStyle: { "font-size": "small !important" } }, [
                _vm._v("(Minor, if custodial account)"),
              ]),
            ]),
            _c("hr", { staticClass: "client-header-underline" }),
          ]),
          _c("sui-grid-column", { attrs: { width: 8 } }, [
            _c("h3", { staticClass: "is-sui-header joint-client-header" }, [
              _vm._v(" Joint Client "),
              _c("span", { staticStyle: { "font-size": "small !important" } }, [
                _vm._v("(Custodian, if custodial account)"),
              ]),
            ]),
            _c("hr", { staticClass: "joint-client-header-underline" }),
          ]),
        ],
        1
      ),
      _c(
        "sui-grid-row",
        [
          _c("ClientInput", {
            attrs: {
              agreement: _vm.agreement,
              states: _vm.states,
              mailPreferenceOptions: _vm.mailPreferenceOptions,
              employmentStatusOptions: _vm.employmentStatusOptions,
              submitted: _vm.submitted,
            },
          }),
          _c("sui-grid-column", { attrs: { width: 8 } }, [
            _c(
              "section",
              [
                _c("sui-form-field", { attrs: { required: "" } }, [
                  _c("label", [_vm._v("Name")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.$v.agreement.JtCltName__c.$model,
                        expression: "$v.agreement.JtCltName__c.$model",
                        modifiers: { trim: true },
                      },
                    ],
                    class: {
                      "is-invalid":
                        _vm.submitted && _vm.$v.agreement.JtCltName__c.$error,
                    },
                    attrs: {
                      type: "text",
                      placeholder: "First Name, Middle Initial, Last Name",
                    },
                    domProps: { value: _vm.$v.agreement.JtCltName__c.$model },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.$v.agreement.JtCltName__c,
                          "$model",
                          $event.target.value.trim()
                        )
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm.submitted && !_vm.$v.agreement.JtCltName__c.required
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(" Enter first name, middle initial, last name "),
                      ])
                    : _vm._e(),
                ]),
              ],
              1
            ),
            _c(
              "section",
              { staticStyle: { "margin-top": "14.9em" } },
              [
                _c(
                  "sui-form-field",
                  [
                    _c("sui-checkbox", {
                      attrs: { label: "Address same as client address" },
                      on: {
                        change: function ($event) {
                          return _vm.setAddressSameAsClientAddress($event)
                        },
                      },
                      model: {
                        value: _vm.isAddressSameClientAddress,
                        callback: function ($$v) {
                          _vm.isAddressSameClientAddress = $$v
                        },
                        expression: "isAddressSameClientAddress",
                      },
                    }),
                  ],
                  1
                ),
                _c("sui-form-field", { attrs: { required: "" } }, [
                  _c("label", [_vm._v("Home Address")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value:
                          _vm.$v.agreement.JtCltHomeAddressStreet__c.$model,
                        expression:
                          "$v.agreement.JtCltHomeAddressStreet__c.$model",
                      },
                    ],
                    class: {
                      "is-invalid":
                        _vm.submitted &&
                        _vm.$v.agreement.JtCltHomeAddressStreet__c.$error,
                    },
                    attrs: { type: "text", placeholder: "Street" },
                    domProps: {
                      value: _vm.$v.agreement.JtCltHomeAddressStreet__c.$model,
                    },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.$v.agreement.JtCltHomeAddressStreet__c,
                          "$model",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm.submitted &&
                  !_vm.$v.agreement.JtCltHomeAddressStreet__c.required
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(" Enter street "),
                      ])
                    : _vm._e(),
                ]),
                _c(
                  "sui-form-fields",
                  [
                    _c(
                      "sui-form-field",
                      { attrs: { width: "six", required: "" } },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.$v.agreement.JtCltHomeAddressCity__c.$model,
                              expression:
                                "$v.agreement.JtCltHomeAddressCity__c.$model",
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.agreement.JtCltHomeAddressCity__c.$error,
                          },
                          attrs: { type: "text", placeholder: "City" },
                          domProps: {
                            value:
                              _vm.$v.agreement.JtCltHomeAddressCity__c.$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.agreement.JtCltHomeAddressCity__c,
                                "$model",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm.submitted &&
                        !_vm.$v.agreement.JtCltHomeAddressCity__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter city "),
                            ])
                          : _vm._e(),
                      ]
                    ),
                    _c(
                      "sui-form-field",
                      { attrs: { width: "six", required: "" } },
                      [
                        _c("sui-dropdown", {
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.agreement.JtCltHomeAddressState__c.$error,
                          },
                          attrs: {
                            placeholder: "State",
                            selection: "",
                            direction: "downward",
                            options: _vm.states,
                          },
                          model: {
                            value:
                              _vm.$v.agreement.JtCltHomeAddressState__c.$model,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.$v.agreement.JtCltHomeAddressState__c,
                                "$model",
                                $$v
                              )
                            },
                            expression:
                              "$v.agreement.JtCltHomeAddressState__c.$model",
                          },
                        }),
                        _vm.submitted &&
                        !_vm.$v.agreement.JtCltHomeAddressState__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter state "),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "sui-form-field",
                      { attrs: { width: "four", required: "" } },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.$v.agreement.JtCltHomeAddressZipCode__c
                                  .$model,
                              expression:
                                "$v.agreement.JtCltHomeAddressZipCode__c.$model",
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.agreement.JtCltHomeAddressZipCode__c
                                .$error,
                          },
                          attrs: { type: "text", placeholder: "Zip" },
                          domProps: {
                            value:
                              _vm.$v.agreement.JtCltHomeAddressZipCode__c
                                .$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.agreement.JtCltHomeAddressZipCode__c,
                                "$model",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm.submitted &&
                        !_vm.$v.agreement.JtCltHomeAddressState__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter zip code "),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "sui-form-field",
                  [
                    _c("sui-checkbox", {
                      attrs: { label: "Home address same as mailing address" },
                      model: {
                        value: _vm.isJtClientHomeAddressSamesAsMailingAddress,
                        callback: function ($$v) {
                          _vm.isJtClientHomeAddressSamesAsMailingAddress = $$v
                        },
                        expression:
                          "isJtClientHomeAddressSamesAsMailingAddress",
                      },
                    }),
                  ],
                  1
                ),
                _c("sui-form-field", { attrs: { required: "" } }, [
                  _c("label", [_vm._v("Mailing Address")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value:
                          _vm.$v.agreement.JtCltMailingAddressStreet__c.$model,
                        expression:
                          "$v.agreement.JtCltMailingAddressStreet__c.$model",
                      },
                    ],
                    class: {
                      "is-invalid":
                        _vm.submitted &&
                        _vm.$v.agreement.JtCltMailingAddressStreet__c.$error,
                    },
                    attrs: { type: "text", placeholder: "Street" },
                    domProps: {
                      value:
                        _vm.$v.agreement.JtCltMailingAddressStreet__c.$model,
                    },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.$v.agreement.JtCltMailingAddressStreet__c,
                          "$model",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm.submitted &&
                  !_vm.$v.agreement.JtCltMailingAddressStreet__c.required
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(" Enter street "),
                      ])
                    : _vm._e(),
                ]),
                _c(
                  "sui-form-fields",
                  [
                    _c(
                      "sui-form-field",
                      { attrs: { width: "six", required: "" } },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.$v.agreement.JtCltMailingAddressCity__c
                                  .$model,
                              expression:
                                "$v.agreement.JtCltMailingAddressCity__c.$model",
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.agreement.JtCltMailingAddressCity__c
                                .$error,
                          },
                          attrs: { type: "text", placeholder: "City" },
                          domProps: {
                            value:
                              _vm.$v.agreement.JtCltMailingAddressCity__c
                                .$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.agreement.JtCltMailingAddressCity__c,
                                "$model",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm.submitted &&
                        !_vm.$v.agreement.JtCltMailingAddressCity__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter city "),
                            ])
                          : _vm._e(),
                      ]
                    ),
                    _c(
                      "sui-form-field",
                      { attrs: { width: "six", required: "" } },
                      [
                        _c("sui-dropdown", {
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.agreement.JtCltMailingAddressState__c
                                .$error,
                          },
                          attrs: {
                            placeholder: "State",
                            selection: "",
                            direction: "downward",
                            options: _vm.states,
                          },
                          model: {
                            value:
                              _vm.$v.agreement.JtCltMailingAddressState__c
                                .$model,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.$v.agreement.JtCltMailingAddressState__c,
                                "$model",
                                $$v
                              )
                            },
                            expression:
                              "$v.agreement.JtCltMailingAddressState__c.$model",
                          },
                        }),
                        _vm.submitted &&
                        !_vm.$v.agreement.JtCltMailingAddressState__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter state "),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "sui-form-field",
                      { attrs: { width: "four", required: "" } },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.$v.agreement.JtCltMailingAddressZipCode__c
                                  .$model,
                              expression:
                                "$v.agreement.JtCltMailingAddressZipCode__c.$model",
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.agreement.JtCltMailingAddressZipCode__c
                                .$error,
                          },
                          attrs: { type: "text", placeholder: "Zip" },
                          domProps: {
                            value:
                              _vm.$v.agreement.JtCltMailingAddressZipCode__c
                                .$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.agreement.JtCltMailingAddressZipCode__c,
                                "$model",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm.submitted &&
                        !_vm.$v.agreement.JtCltMailingAddressZipCode__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter zip code "),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
                _c("sui-form-field", [
                  _c("label", [_vm._v("Work Address")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.agreement.JtCltWorkAddressStreet__c,
                        expression: "agreement.JtCltWorkAddressStreet__c",
                      },
                    ],
                    attrs: { type: "text", placeholder: "Street" },
                    domProps: {
                      value: _vm.agreement.JtCltWorkAddressStreet__c,
                    },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.agreement,
                          "JtCltWorkAddressStreet__c",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _c(
                  "sui-form-fields",
                  [
                    _c("sui-form-field", { attrs: { width: "six" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.agreement.JtCltWorkAddressCity__c,
                            expression: "agreement.JtCltWorkAddressCity__c",
                          },
                        ],
                        attrs: { type: "text", placeholder: "City" },
                        domProps: {
                          value: _vm.agreement.JtCltWorkAddressCity__c,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.agreement,
                              "JtCltWorkAddressCity__c",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _c(
                      "sui-form-field",
                      { attrs: { width: "six" } },
                      [
                        _c("sui-dropdown", {
                          attrs: {
                            placeholder: "States",
                            selection: "",
                            direction: "downward",
                            options: _vm.states,
                          },
                          model: {
                            value: _vm.agreement.JtCltWorkAddressState__c,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.agreement,
                                "JtCltWorkAddressState__c",
                                $$v
                              )
                            },
                            expression: "agreement.JtCltWorkAddressState__c",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("sui-form-field", { attrs: { width: "four" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.agreement.JtCltWorkAddressZipCode__c,
                            expression: "agreement.JtCltWorkAddressZipCode__c",
                          },
                        ],
                        attrs: { type: "text", placeholder: "Zip" },
                        domProps: {
                          value: _vm.agreement.JtCltWorkAddressZipCode__c,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.agreement,
                              "JtCltWorkAddressZipCode__c",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "section",
              { staticStyle: { "margin-top": "4em" } },
              [
                _c(
                  "sui-form-fields",
                  { attrs: { "equal-width": "" } },
                  [
                    _c(
                      "sui-form-field",
                      { attrs: { required: "" } },
                      [
                        _c("Label", [_vm._v("Cell Phone")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.$v.agreement.JtCltCellPhone__c.$model,
                              expression:
                                "$v.agreement.JtCltCellPhone__c.$model",
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.agreement.JtCltCellPhone__c.$error,
                          },
                          attrs: { type: "text", placeholder: "Cell Phone" },
                          domProps: {
                            value: _vm.$v.agreement.JtCltCellPhone__c.$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.agreement.JtCltCellPhone__c,
                                "$model",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm.submitted &&
                        !_vm.$v.agreement.JtCltCellPhone__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter cell phone "),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "sui-form-field",
                      { attrs: { required: "" } },
                      [
                        _c("Label", [_vm._v("Business Phone")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.$v.agreement.JtCltBusinessPhone__c.$model,
                              expression:
                                "$v.agreement.JtCltBusinessPhone__c.$model",
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.agreement.JtCltBusinessPhone__c.$error,
                          },
                          attrs: {
                            type: "text",
                            placeholder: "Business Phone",
                          },
                          domProps: {
                            value:
                              _vm.$v.agreement.JtCltBusinessPhone__c.$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.agreement.JtCltBusinessPhone__c,
                                "$model",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm.submitted &&
                        !_vm.$v.agreement.JtCltBusinessPhone__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter business phone "),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "sui-form-fields",
                  { attrs: { "equal-width": "" } },
                  [
                    _c(
                      "sui-form-field",
                      { attrs: { required: "" } },
                      [
                        _c("Label", [_vm._v("Home Phone")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.$v.agreement.JtCltHomePhone__c.$model,
                              expression:
                                "$v.agreement.JtCltHomePhone__c.$model",
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.agreement.JtCltHomePhone__c.$error,
                          },
                          attrs: { type: "text", placeholder: "Home Phone" },
                          domProps: {
                            value: _vm.$v.agreement.JtCltHomePhone__c.$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.agreement.JtCltHomePhone__c,
                                "$model",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm.submitted &&
                        !_vm.$v.agreement.JtCltHomePhone__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter home phone "),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "sui-form-field",
                      { attrs: { required: "" } },
                      [
                        _c("Label", [_vm._v("Email Address")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.$v.agreement.JtCltEmailAddress__c.$model,
                              expression:
                                "$v.agreement.JtCltEmailAddress__c.$model",
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.agreement.JtCltEmailAddress__c.$error,
                          },
                          attrs: {
                            type: "email",
                            placeholder: "Email Address",
                          },
                          domProps: {
                            value: _vm.$v.agreement.JtCltEmailAddress__c.$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.agreement.JtCltEmailAddress__c,
                                "$model",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm.submitted &&
                        !_vm.$v.agreement.JtCltEmailAddress__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter email address "),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "sui-form-field",
                  { attrs: { width: 8, required: "" } },
                  [
                    _c("label", [_vm._v("Mail Preference")]),
                    _c("sui-dropdown", {
                      class: {
                        "is-invalid":
                          _vm.submitted &&
                          _vm.$v.agreement.JtCltMailPreference__c.$error,
                      },
                      attrs: {
                        placeholder: "Mail Preference",
                        selection: "",
                        direction: "downward",
                        options: _vm.mailPreferenceOptions,
                      },
                      model: {
                        value: _vm.$v.agreement.JtCltMailPreference__c.$model,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.$v.agreement.JtCltMailPreference__c,
                            "$model",
                            $$v
                          )
                        },
                        expression:
                          "$v.agreement.JtCltMailPreference__c.$model",
                      },
                    }),
                    _vm.submitted &&
                    !_vm.$v.agreement.JtCltMailPreference__c.required
                      ? _c("div", { staticClass: "invalid-feedback" }, [
                          _vm._v(" Enter employment status "),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "section",
              { staticStyle: { "margin-top": "4em" } },
              [
                _c(
                  "sui-form-field",
                  { attrs: { width: 8, required: "" } },
                  [
                    _c("label", [_vm._v("Employment Status")]),
                    _c("sui-dropdown", {
                      class: {
                        "is-invalid":
                          _vm.submitted &&
                          _vm.$v.agreement.JtCltEmploymentStatus__c.$error,
                      },
                      attrs: {
                        placeholder: "Employment Status",
                        selection: "",
                        direction: "downward",
                        options: _vm.employmentStatusOptions,
                      },
                      model: {
                        value: _vm.$v.agreement.JtCltEmploymentStatus__c.$model,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.$v.agreement.JtCltEmploymentStatus__c,
                            "$model",
                            $$v
                          )
                        },
                        expression:
                          "$v.agreement.JtCltEmploymentStatus__c.$model",
                      },
                    }),
                    _vm.submitted &&
                    !_vm.$v.agreement.JtCltEmploymentStatus__c.required
                      ? _c("div", { staticClass: "invalid-feedback" }, [
                          _vm._v(" Enter employment status "),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "sui-form-fields",
                  { attrs: { "equal-width": "" } },
                  [
                    _c(
                      "sui-form-field",
                      [
                        _c("Label", [_vm._v("Employer")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.agreement.JtCltEmployer__c,
                              expression: "agreement.JtCltEmployer__c",
                            },
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "Former if retired or unemployed",
                          },
                          domProps: { value: _vm.agreement.JtCltEmployer__c },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.agreement,
                                "JtCltEmployer__c",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "sui-form-field",
                      [
                        _c("Label", [_vm._v("Occupation")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.agreement.JtCltOccupation__c,
                              expression: "agreement.JtCltOccupation__c",
                            },
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "Former if retired or unemployed",
                          },
                          domProps: { value: _vm.agreement.JtCltOccupation__c },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.agreement,
                                "JtCltOccupation__c",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "sui-form-fields",
                  { attrs: { inline: "" } },
                  [
                    _c(
                      "label",
                      { staticStyle: { "margin-right": "10px!important" } },
                      [
                        _vm._v(
                          " Are you employed by a broker-dealer, securities exchange, or FINRA? "
                        ),
                      ]
                    ),
                    _c(
                      "sui-form-field",
                      [
                        _c("sui-checkbox", {
                          model: {
                            value:
                              _vm.agreement.IsJtCltEmployedByBrokerDealer__c,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.agreement,
                                "IsJtCltEmployedByBrokerDealer__c",
                                $$v
                              )
                            },
                            expression:
                              "agreement.IsJtCltEmployedByBrokerDealer__c",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "sui-form-fields",
                  { attrs: { inline: "" } },
                  [
                    _c(
                      "label",
                      { staticStyle: { "margin-right": "10px!important" } },
                      [
                        _vm._v(
                          " Are you a senior officer, director, or large shareholder of a public company? "
                        ),
                      ]
                    ),
                    _c(
                      "sui-form-field",
                      [
                        _c("sui-checkbox", {
                          model: {
                            value:
                              _vm.agreement
                                .IsJtCltSeniorOfficerOfPublicCompany__c,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.agreement,
                                "IsJtCltSeniorOfficerOfPublicCompany__c",
                                $$v
                              )
                            },
                            expression:
                              "agreement.IsJtCltSeniorOfficerOfPublicCompany__c",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.agreement.IsJtCltSeniorOfficerOfPublicCompany__c
                  ? _c("sui-form-field", { attrs: { width: 8 } }, [
                      _c("label", [_vm._v("Public Company Name")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.agreement.JtCltPublicCompany__c,
                            expression: "agreement.JtCltPublicCompany__c",
                          },
                        ],
                        attrs: { type: "text", placeholder: "Company Name" },
                        domProps: {
                          value: _vm.agreement.JtCltPublicCompany__c,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.agreement,
                              "JtCltPublicCompany__c",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ])
                  : _vm._e(),
                _c(
                  "sui-form-fields",
                  { attrs: { "equal-width": "" } },
                  [
                    _c(
                      "sui-form-field",
                      { attrs: { required: "" } },
                      [
                        _c("Label", [_vm._v("Date of Birth")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.$v.agreement.JtCltDoB__c.$model,
                              expression: "$v.agreement.JtCltDoB__c.$model",
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.agreement.JtCltDoB__c.$error,
                          },
                          attrs: { type: "text", placeholder: "MM/DD/YYYY" },
                          domProps: {
                            value: _vm.$v.agreement.JtCltDoB__c.$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.agreement.JtCltDoB__c,
                                "$model",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm.submitted && !_vm.$v.agreement.JtCltDoB__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter date of birth "),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "sui-form-field",
                      { attrs: { required: "" } },
                      [
                        _c("Label", [_vm._v("SSN")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.$v.agreement.JtCltSSN__c.$model,
                              expression: "$v.agreement.JtCltSSN__c.$model",
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.agreement.JtCltSSN__c.$error,
                          },
                          attrs: { type: "text", placeholder: "SSN" },
                          domProps: {
                            value: _vm.$v.agreement.JtCltSSN__c.$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.agreement.JtCltSSN__c,
                                "$model",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm.submitted && !_vm.$v.agreement.JtCltSSN__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter social security number "),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "sui-form-field",
                  [
                    _c(
                      "sui-form-fields",
                      { attrs: { "equal-width": "" } },
                      [
                        _c("sui-form-field", { attrs: { required: "" } }, [
                          _c("label", [_vm._v("Driver's License Number")]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.$v.agreement.JtCltDriversLicense__c
                                    .$model,
                                expression:
                                  "$v.agreement.JtCltDriversLicense__c.$model",
                              },
                            ],
                            class: {
                              "is-invalid":
                                _vm.submitted &&
                                _vm.$v.agreement.JtCltDriversLicense__c.$error,
                            },
                            attrs: {
                              type: "text",
                              placeholder: "Driver's License Number",
                            },
                            domProps: {
                              value:
                                _vm.$v.agreement.JtCltDriversLicense__c.$model,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.agreement.JtCltDriversLicense__c,
                                  "$model",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm.submitted &&
                          !_vm.$v.agreement.JtCltDriversLicense__c.required
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(" Enter drivers license number "),
                              ])
                            : _vm._e(),
                        ]),
                        _c("sui-form-field", { attrs: { required: "" } }, [
                          _c("label", [
                            _vm._v(
                              "Driver's License State or Country of Issuance"
                            ),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.$v.agreement
                                    .JtCltDriversLicenseIssueState__c.$model,
                                expression:
                                  "$v.agreement.JtCltDriversLicenseIssueState__c.$model",
                              },
                            ],
                            class: {
                              "is-invalid":
                                _vm.submitted &&
                                _vm.$v.agreement
                                  .JtCltDriversLicenseIssueState__c.$error,
                            },
                            attrs: {
                              type: "text",
                              placeholder: "State or Country of Issuance",
                            },
                            domProps: {
                              value:
                                _vm.$v.agreement
                                  .JtCltDriversLicenseIssueState__c.$model,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.agreement
                                    .JtCltDriversLicenseIssueState__c,
                                  "$model",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm.submitted &&
                          !_vm.$v.agreement.JtCltDriversLicenseIssueState__c
                            .required
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(" Enter drivers license issue state "),
                              ])
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "sui-form-fields",
                  { attrs: { "equal-width": "" } },
                  [
                    _c("sui-form-field", { attrs: { required: "" } }, [
                      _c("label", [_vm._v("Driver's License Issue Date")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.$v.agreement.JtCltDriversLicenseIssueDate__c
                                .$model,
                            expression:
                              "$v.agreement.JtCltDriversLicenseIssueDate__c.$model",
                          },
                        ],
                        class: {
                          "is-invalid":
                            _vm.submitted &&
                            _vm.$v.agreement.JtCltDriversLicenseIssueDate__c
                              .$error,
                        },
                        attrs: { type: "text", placeholder: "MM/DD/YYYY" },
                        domProps: {
                          value:
                            _vm.$v.agreement.JtCltDriversLicenseIssueDate__c
                              .$model,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.agreement.JtCltDriversLicenseIssueDate__c,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm.submitted &&
                      !_vm.$v.agreement.JtCltDriversLicenseIssueDate__c.required
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(" Enter drivers license issue date "),
                          ])
                        : _vm._e(),
                    ]),
                    _c("sui-form-field", { attrs: { required: "" } }, [
                      _c("label", [_vm._v("Driver's License Expiration Date")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.$v.agreement
                                .JtCltDriversLicenseExpirationDate__c.$model,
                            expression:
                              "$v.agreement.JtCltDriversLicenseExpirationDate__c.$model",
                          },
                        ],
                        class: {
                          "is-invalid":
                            _vm.submitted &&
                            _vm.$v.agreement
                              .JtCltDriversLicenseExpirationDate__c.$error,
                        },
                        attrs: { type: "text", placeholder: "MM/DD/YYYY" },
                        domProps: {
                          value:
                            _vm.$v.agreement
                              .JtCltDriversLicenseExpirationDate__c.$model,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.agreement
                                .JtCltDriversLicenseExpirationDate__c,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm.submitted &&
                      !_vm.$v.agreement.JtCltDriversLicenseExpirationDate__c
                        .required
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(" Enter drivers license expiration date "),
                          ])
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }